<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :include="keepAlive" :max="10">
      <component
        :is="Component"
        :key="refreshPage.some(item => route.path.includes(item)) || 'id' in route.params ? route.path : route.fullPath"
      />
    </keep-alive>
  </router-view>
</template>
<script setup lang="ts">
import { initSSE } from '@/utils/sse';
import useLogin from '@/hooks/useLogin';

// 需要缓存的组件名称，对应组件要写名字，切记要组件起名字（规则和路径保持一致） , 'buyer-order','sold-order'
const keepAlive = ref(['HelpCenter', 'help-center-artice-content', 'help-center-artice']);
// 页面路径添加路径参数 不刷新页面 'id' in route.params 是动态路由部分添加参数 不刷新页面
const refreshPage = ref(['gift-cards', 'games', 'subscriptions', 'software', 'game-points', 'fc26-boosting']);
const { isLogin } = useLogin();
onMounted(() => {
  if (isLogin()) {
    initSSE(`${import.meta.env.VITE_APP_PATH_SSE}/member/indexSse`);
  }
});
</script>
<!-- <style lang="scss" scoped>
@mixin slide-transform($tran: 30px, $opt: 0) {
  opacity: $opt;
  transform: translate($tran, 0);
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.2s;
}
.slide-left-enter-from {
  @include slide-transform(30px);
}
.slide-left-leave-to {
  @include slide-transform(-30px);
}
.slide-right-enter-from {
  @include slide-transform(-30px);
}
.slide-right-leave-to {
  @include slide-transform(30px);
}
</style> -->
